import { render } from "./Icon.htm?vue&type=template&id=4f50b036&scoped=true"
import script from "./Icon.js?vue&type=script&lang=js"
export * from "./Icon.js?vue&type=script&lang=js"

import "./Icon.scss?vue&type=style&index=0&id=4f50b036&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f50b036"]])

export default __exports__